var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cx-slider__item -center",style:({
    transition: _vm.silence ? undefined : `all ${_vm.timeBreak}s`,
    '-ms-transform': `translateX(${ _vm.translate }px)`,
    '-webkit-tranform': `translateX(${ _vm.translate }px)`,
    transform: `translateX(${ _vm.translate }px)`,
    backgroundColor: _vm.bg ? null : 'unset'
  })},[_vm._t("default",null,{"focusHandler":_vm.focusHandler,"blurHandler":_vm.blurHandler})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }